<template>
  <el-dialog title="选择商品"
             :visible.sync="visible"
             width="840px"
             :close-on-press-escape="false"
             @closed="handleClosed">
    <el-form :inline="true"
             @submit.native.prevent
             style="display:flex;justify-content: space-between;">
      <el-form-item>
      </el-form-item>
      <el-form-item>
        <el-input placeholder="请输入商品名称"
                  v-model="config.productName"
                  style="width: 200px">
          <el-button slot="append"
                     icon="el-icon-search"
                     @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <el-table ref="table"
              border
              v-loading="loading"
              :data="list"
              @selection-change="handleSelectionChange">
      <el-table-column type="selection"
                       :selectable="selectable"
                       width="50">
      </el-table-column>
      <el-table-column label="商品名称"
                       min-width="200"
                       prop="productName">
      </el-table-column>
      <el-table-column label="备注"
                       min-width="180"
                       prop="productNameRemark">
      </el-table-column>
      <el-table-column label="商品类型"
                       min-width="80"
                       prop="categoryName">
      </el-table-column>
      <el-table-column label="赋码方式"
                       min-width="80">
        <template slot-scope="{row}">{{ row.codingType | codingType()}}</template>
      </el-table-column>
      <el-table-column label="标签类型"
                       min-width="80">
        <template slot-scope="{row}">{{ row.tagType | tagType()}}</template>
      </el-table-column>
      <el-table-column label="操作"
                       width="60">
        <template slot-scope="{row}">
          <el-button type="text"
                     :disabled="!selectable(row)"
                     @click="addItem(row)">{{ !selectable(row) ? '已添加' : '添加' }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background
                   style="text-align: center;margin-top: 8px;"
                   @current-change="handleCurrentChange"
                   :current-page.sync="config.pageNum"
                   :page-size="config.pageSize"
                   layout="total, prev, pager, next"
                   :total="total">
    </el-pagination>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="visible = false"
                 :loading="loading">取 消</el-button>
      <el-button type="primary"
                 @click="handleSubmit"
                 :loading="loading">批量添加</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'product-select-modal-new',
  props: {
    option: { type: Object }
  },
  data () {
    return {
      loading: false,
      visible: false,
      config: { pageNum: 1, pageSize: 10, productName: '', status: 2 },
      list: [],
      total: 0,
      selection: [],
      multipleSelection: []
    }
  },
  methods: {
    selectable (row) {
      return !this.selection.includes(row.productId)
    },
    addItem (row) {
      this.$emit('add', [{ ...row, goodsCount: row.codingType === 2 ? 0 : 1 }])
      this.selection.push(row.productId)
      this.$refs.table && this.$refs.table.clearSelection()
      this.$message.success('添加成功')
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      this.$store.dispatch('product/getproducts', {
        payload: { ...this.config, ...this.option },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleClosed () {
      this.selection = []
      this.config = { ...this.config, ...this.$options.data().config }
      this.list = []
      this.total = 0
      this.multipleSelection = []
    },
    handleSubmit () {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请选择商品')
        return
      }
      this.$emit('add', this.multipleSelection.map(o => ({ ...o, goodsCount: o.codingType === 2 ? 0 : 1 })))
      this.$message.success('添加成功')
      this.selection.push(...this.multipleSelection.map(i => i.productId))
      this.$refs.table && this.$refs.table.clearSelection()
    },
    fetch (list) {
      this.selection = list
      this.visible = true
      this.fetchList()
    }
  }
}
</script>
<style lang="stylus" scoped></style>
